// covered-by: frontends/carrie/src/ask-v2/rail/__tests__/AskV2RightRail.test.tsx
import { type ComponentProps } from "react";

import { ReviewListCard } from "../../components/ask-puntt-review/ReviewListCard";

/**
 * Output-rail review rows sit in a fixed 320px column; the shared card is also
 * used in wider V1 surfaces. Clip and min-width here so long titles and meta
 * rows truncate instead of spilling past the rail.
 */
// why-not: no overflow-hidden on this wrapper — it sits on the same box as the row
// button shadow/focus ring; min-width + truncate on inner text still contain GEN-334 spill.
export const ASK_V2_RAIL_REVIEW_CARD_CLIP_CLASS =
  "min-w-0 w-full max-w-full [&>button]:min-w-0 [&>button]:max-w-full [&_[data-testid$='-row']]:min-w-0";

export function AskV2RailReviewCard(
  props: ComponentProps<typeof ReviewListCard>,
) {
  return (
    <div className={ASK_V2_RAIL_REVIEW_CARD_CLIP_CLASS}>
      <ReviewListCard {...props} />
    </div>
  );
}
